import { render, staticRenderFns } from "./XRayClickRegions.vue?vue&type=template&id=3f01da58&"
import script from "./XRayClickRegions.vue?vue&type=script&lang=js&"
export * from "./XRayClickRegions.vue?vue&type=script&lang=js&"
import style0 from "./XRayClickRegions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports